import * as types from './types';

const INITIAL_STATE = Object.freeze({
  pageNumber: 1,
  pageSize: 10,
  filter: [],
  sortColumn: [],

  loading: false,
  error: null,
  pageResult: null,
  searchParameters: {},
});

export default function createCommonStatePagingReducer(prefix) {
  return function (state = INITIAL_STATE, { type, payload }) {
    switch (type) {
      case types[`${prefix}PAGING_RESET`]:
        return {
          ...INITIAL_STATE,
        };
      case types[`${prefix}PAGING_FETCHING`]:
        return {
          ...state,
          loading: payload,
          error: null,
        };
      case types[`${prefix}PAGING_ERROR`]:
        return {
          ...state,
          error: payload,
        };
      case types[`${prefix}PAGING_SUCCESS`]:
        return {
          ...state,
          pageResult: payload,
        };

      case types[`${prefix}PAGING_SET_PAGE_NUMBER`]:
        return {
          ...state,
          pageNumber: payload,
        };
      case types[`${prefix}PAGING_SET_PAGE_SIZE`]:
        return {
          ...state,
          pageSize: payload.pageSize,
          ...(payload.pageNumber && { pageNumber: payload.pageNumber }),
        };
      case types[`${prefix}PAGING_SET_SORT_COLUMN`]:
        return {
          ...state,
          sortColumn: payload,
        };
      case types[`${prefix}PAGING_SET_FILTER`]:
        return {
          ...state,
          filter: payload,
        };
      case types[`${prefix}PAGING_SET_SEARCH_PARAMETERS`]:
        return {
          ...state,
          searchParameters: payload,
        };
      default:
        return state;
    }
  };
}



// WEBPACK FOOTER //
// ./src/state/paging/reducer.js